<template>
    <div v-if="!sameAsShippingAddress" class="national-shipping">
        <div class="national-shipping__address-form">
            <Address 
                :zip-code.sync="zipCode"
                :street.sync="street"
                :number.sync="number"
                :complement.sync="complement"
                :district.sync="district"
                :city.sync="city"
                :state.sync="state"

                :disable-street="disableStreet"
                :disable-district="disableDistrict"
                :disable-city="disableCity"
                :disable-state="disableState"

                :address-errors.sync="innerAddressErrors"

                @postalCodeFetched="onZipCodeFetched"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Address from '@/components/Address';
    import { attr_accessor } from '@/services/VuexAcessor';

    export default {
        components: {
            Address
        },

        data() {
            return {
                innerAddressErrors: {}
            };
        },

        mounted() {
            this.$emit('update:addressErrors', this.innerAddressErrors);
        },

        computed: {
            ...mapGetters({
                sameAsShippingAddress: 'billingAddress/getSameAsShippingAddress',
            }),

            disableStreet: self => false,
            disableDistrict: self => false,
            disableCity: self => self.fetchedFields.includes('city'),
            disableState: self => self.fetchedFields.includes('state'),

            /**
             * Dados a serem sincronizados com o storage
             */
            zipCode: attr_accessor(state => state.billingAddress.ZipCode, 'billingAddress/setZipCode'),
            street: attr_accessor(state => state.billingAddress.Street, 'billingAddress/setStreet'),
            number: attr_accessor(state => state.billingAddress.Number, 'billingAddress/setNumber'),
            complement: attr_accessor(state => state.billingAddress.Complement, 'billingAddress/setComplement'),
            district: attr_accessor(state => state.billingAddress.District, 'billingAddress/setDistrict'),
            city: attr_accessor(state => state.billingAddress.City, 'billingAddress/setCity'),
            state: attr_accessor(state => state.billingAddress.State, 'billingAddress/setState'),

            fetchedFields:{
                get: self => self.$store.state.billingAddress.FetchedFields
            },
        },

        watch: {
            billingAddressType(value) {
                if (value) {
                    if (!this.$refs.billing_address_type) return;
                    this.$refs.billing_address_type.style.visibility = 'visible';
                }
            }
        },

        methods: {
            onZipCodeFetched(response) {
                this.$store.commit('billingAddress/setFromRequest', response.fields);
            }
        },

        props: {
            addressErrors: {
                type: Object,
                default() {
                    return {};
                }
            },
        }
    };
</script>

<style lang="scss" scoped>

    .national-shipping {
        margin-top: 20px;
        &__title {
            display: block;
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            color: #2F363E;
            margin-bottom: 20px;
        }
    }
</style>